import React, { useState } from "react";
import { IonInput, IonButton, IonBadge } from "@ionic/react";
import styled from "styled-components";

import AccordionPanel from "../accordion-panel";
import strings from "../../../../res/strings";

const PanelMessage = styled.div`
  color: #666666;
  margin-top: 16px;
`;
const PanelInputContainer = styled.div`
  margin-top: 16px;
`;
const PanelInputInstructions = styled.div`
  color: #666666;
`;
const PanelInputInstructionsValue = styled(IonBadge)`
  margin: 2px 0px 2px 0px;
  padding: 2px 8px 2px 8px;
  display: block;
  width: fit-content;
  font-weight: normal;
`;
const PanelInput = styled(IonInput)`
  margin: 16px 0px 16px 0px;
  border: 1px solid #868686;
  border-radius: 4px;
`;
const PanelButtonContainer = styled.div``;
const PanelButton = styled(IonButton)`
  width: 100%;
`;

const DeleteConfirmPanel = (props) => {
  const [confirmInput, setConfirmInput] = useState("");

  return (
    <AccordionPanel
      title={props.title}
      titleStyle={props.titleStyle ? props.titleStyle : { color: "#eb445a" }}
    >
      <PanelMessage>{props.instructions}</PanelMessage>
      <PanelInputContainer>
        <PanelInputInstructions>
          {props.inputInstructions}
          <PanelInputInstructionsValue color="warning">
            {props.deleteIdentifier}
          </PanelInputInstructionsValue>
        </PanelInputInstructions>
        <PanelInput
          placeholder={strings.lib_common_placeholder_type_here}
          onIonChange={(e) => {
            setConfirmInput(e.target.value);
          }}
        />
      </PanelInputContainer>
      <PanelButtonContainer>
        <PanelButton
          color="danger"
          disabled={confirmInput !== props.deleteIdentifier}
          onClick={props.onConfirm}
        >
          {strings.lib_common_action_delete_confirm}
        </PanelButton>
      </PanelButtonContainer>
    </AccordionPanel>
  );
};

export default DeleteConfirmPanel;
